import React, { useEffect } from "react";
import passengerIcon from "../imgs/add-passenger.png"
import safetyIcon from "../imgs/traffic-light.png"
import maintenanceIcon from "../imgs/maintenance.png"
import benefitsIcon from "../imgs/benefits.png"
import gasoline from "../imgs/gasoline.png";
import book from "../imgs/open-book.png"
import accidentsIcon from "../imgs/airbag.png"
import documentIcon from "../imgs/document.png"
import express from "../imgs/express.png"
import news from "../imgs/newspaper.png"


import scanIcon from '../imgs/work/qr-scan.png';
import {Link} from "react-router-dom";
import { IonPage, IonHeader, IonToolbar, IonContent, IonFooter, createGesture } from "@ionic/react";
import Nav from "./Nav";
import Toolbar from "./Toolbar";
import { sidnavStore, SidenavState } from "../api/SidenavStore";

//walkthrough import
import DocsFirstIn from "../components/walkthrough/DocsFirstIn";

const Docs = () => {

        const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
        const {toggleSidenav}: { toggleSidenav: () => void } = sidnavStore((state: SidenavState) => ({toggleSidenav: state.toggle}));
        
        const ref = React.useRef<HTMLInputElement>(null)
    
        useEffect(() => {
            gestureInit();
        }, [])
    
        const gestureInit = () => {
            const card = ref.current
            if (card) {
                const gesture = createGesture({
                    el: card,
                    gestureName: 'swipeMenu',
                    onMove: (detail) => {
                        console.log("moving");
                    },
                    onEnd: (detail) => {
                        console.log("move ended");
                        toggleSidenav();
                    }                 
                })
                gesture.enable();
            }
        }

    return (
        <IonPage>
        <IonHeader>
            <IonToolbar color="primary">
                <Toolbar pageName="Docs"/>
            </IonToolbar>
        </IonHeader>
        <IonContent fullscreen color="light">
            <div ref={ref} onClick={() => close()} style={{height: "80vh"}}>
                <div className="item-container">
                    <div id="WholeDocsSection">
                        <div className="grid50">
                            <Link className="western-button-link" to="/safety">
                                <div>
                                    <img src={safetyIcon} alt="key" className="link-icon"/><p>Safety</p>
                                </div>
                            </Link>
                        
                            <Link className="western-button-link" to="/maintenancevids">
                                <div>
                                    <img src={maintenanceIcon} alt="key" className="link-icon"/><p>Maintenance</p>
                                </div>
                            </Link>

                            <Link className="western-button-link" to="/benefits">
                                <div>
                                    <img src={benefitsIcon} alt="key" className="link-icon"/><p>Benefits</p>
                                </div>
                            </Link>

                            <Link className="western-button-link" to="/permits">
                                <div>
                                    <img alt="key" className="link-icon" src={documentIcon} /><p>Permits</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <Link className="western-button-link" to="/contracts" id="Accident">
                        <div>
                            <img src={news} alt="key" className="link-icon"/><p>Contracts</p>
                        </div>
                    </Link>
                    
                    <Link className="western-button-link" to="/accidentinfo" id="Accident">
                        <div className="red">
                            <img src={accidentsIcon} alt="key" className="link-icon"/><p>Accidents</p>
                        </div>
                    </Link>
                </div>
            </div>
        </IonContent>
        <IonFooter>
            <Nav pageName="Docs" onSearch={function (target: boolean): void {
                    console.log("Not ready");
                } }/>
        </IonFooter>
        </IonPage>
    )
}

export default Docs
